import React, { useEffect } from 'react';
import './NewsletterModal.scss';
import { safeHtml } from '../../../../services/helpers';
import SvgIcons from '../../../../services/SvgIcons';

export default function NewsletterModal({ content, onClose }) {

    useEffect(() => {
            // Désactiver le scroll du body quand le composant est monté
            document.body.style.overflow = 'hidden';
    
            // Réactiver le scroll quand le composant est démonté
            return () => {
                document.body.style.overflow = '';
            };
        }, []);
    
        const handleOverlayClick = (e) => {
            if (e.target === e.currentTarget) {
                onClose();
            }
        };

    return (
        <div className="newsletter-modal" onClick={handleOverlayClick}>
            <div className="newsletter-modal__content">
                <SvgIcons
                    name={'close'}
                    width={50}
                    height={50}
                    color={'#eee6db'}
                    onClick={onClose}
                    cursor={'pointer'}
                    position={'absolute'}
                    top={10}
                    right={10}
                />
                <div className="newsletter-modal__header">
                    <picture className='newsletter-modal__logo'>
                        <source srcSet={'/assets/logo_white.webp'} type="image/webp" />
                        <img src={'/assets/logo_white.png'} alt="Logo Grandir & s'élever ensemble" loading="eager" fetchpriority="high" />
                    </picture>
                </div>
                <div className="newsletterthanks__text" dangerouslySetInnerHTML={safeHtml(content.Remerciements.Texte)} />
                

                <p className="newsletter-modal__privacy">
                    Ton adresse email ne sera jamais partagée
                </p>
            </div>
        </div>
    );
}